module.exports = jQuery;


//////////////////
// WEBPACK FOOTER
// external "jQuery"
// module id = 32
// module chunks = 0 1 10 11 14 15 16 17 23 26 29 30 36 44 45 49